import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstNewItemReceiptColSlice = createSlicePrototype({
    name: "getAllMstNewItemReceiptCol"
});
export var getAllMstNewItemReceiptCol = createFetchMaster({
    actions: getAllMstNewItemReceiptColSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_NEW_ITEM_RECEIPT_COL
    }
});
var _getAllMstNewItemReceiptColSlice_actions = getAllMstNewItemReceiptColSlice.actions;
export var fetchData = _getAllMstNewItemReceiptColSlice_actions.fetchData, fetchDataSuccess = _getAllMstNewItemReceiptColSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstNewItemReceiptColSlice_actions.fetchDataFailure, resetState = _getAllMstNewItemReceiptColSlice_actions.resetState;
export default getAllMstNewItemReceiptColSlice.reducer;
